
import { useEffect, useRef } from "react";
import lottie from 'lottie-web';
import finex_lottie from "../util/finex_lottie.json"
import React from "react";
const Loading = () => {
    const animationContainer = useRef<any>(null);

    useEffect(() => {
        lottie.loadAnimation({
            container: animationContainer.current,
            animationData: finex_lottie,
            renderer: 'svg',
            loop: true,
            autoplay: true,
        });

        return () => lottie.destroy(); // Dọn dẹp khi component unmount
    }, []);
    return (
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center z-[100] bg-white">
            <div className="w-[400x] h-[400px]" ref={animationContainer}></div>
        </div>
    )
}
export default Loading